<section>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="user-dashboard-info-box mb-0">
            <div class="row mb-4">
              <div class="col-md-7 col-sm-5 d-flex align-items-center">
                <div class="section-title-02 mb-0 ">
                  <h4 class="mb-0">Job Invites</h4>
                </div>
              </div>
              <div class="col-md-5 col-sm-7 mt-3 mt-sm-0">
                <div class="search">
                  <i class="fas fa-search"></i>
                  <input type="text" class="form-control" placeholder="Search...." [(ngModel)]="searchText">
                </div>
              </div>
            </div>
            <div class="user-dashboard-table table-responsive">
              <table class="table table-bordered">
                <thead class="bg-light">
                  <tr>
                    <th scope="col">Job Title</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let jobPost of jobPosts | jobPostsFilter: searchText">
                    <th scope="row"><a role="button" [routerLink]="" (click)="viewInvite(jobPost.id, jobPost.employerAccountId)" class="text-primary" data-toggle="tooltip" title="view">{{jobPost.title}}</a>
                      <p class="mb-1 mt-2">Expiry: {{jobPost.expiryDate | date}}</p>
                      <p class="mb-0">Location: {{jobPost.city}} {{jobPost.country}}</p>
                    </th>
                    <td>
                      <ul class="list-unstyled mb-0 d-flex">
                        <li><a role="button" [routerLink]="" (click)="viewInvite(jobPost.id, jobPost.employerAccountId)" class="text-primary" data-toggle="tooltip" title="view"><i
                              class="far fa-eye"></i></a></li>
                        <li><a role="button" [routerLink]="" (click)="declineInvite(jobPost.id)" class="text-danger" title="Decline"><i
                              class="far fa-trash-alt"></i></a></li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>